import React from "react";
import { Container, Row, Col } from "react-bootstrap";

function ArchResult() {
  const handleDownload = (e) => {
    e.preventDefault();
    // Implement your download logic here
    console.log("Downloading ZIP file...");
  };

  return (
    <div className="page-wrapper database-conversion-page px-3">
      <Container>
        <Row>
          <Col>
            <h2 className="page-title">Architecture Based Conversion Result</h2>
            <div className="result-summary">
              <strong>Success!</strong> The Architecture Based Conversion has been completed successfully.
                You can now download the converted files using the button below.
            </div>
            
          </Col>
        </Row>
        <Row>
          <Col className="text-end">
            <button onClick={handleDownload} className="btn btn-primary">
              Download the ZIP
            </button>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default ArchResult;